import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayArrowFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-273.78 -348.44 1955.56 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1384 609 56 -129Q33 -142 16.5 -132.0Q0 -122 0 -96V1376Q0 1402 16.5 1412.0Q33 1422 56 1409L1384 671Q1407 658 1407.0 640.0Q1407 622 1384 609Z"
	})
});
export default SvgPlayArrowFill;
